import axios from 'axios';
import { CodeInfos } from './legislationCode.types';

export async function getCodeInfos(
  textId: string,
  date: Date,
): Promise<CodeInfos> {
  return (
    await axios.get(`/api/legislation/codes/${textId}`, { params: { date } })
  ).data;
}

export async function getSectionInfos(
  textId: string,
  sectionId: string,
  date: Date,
): Promise<CodeInfos> {
  return (
    await axios.get(`/api/legislation/codes/${textId}/sections/${sectionId}`, {
      params: { date },
    })
  ).data;
}
